const MINUTES_PER_HOUR = 60;

const formatOffset = (offsetMinutes: number): string => {
  const sign = offsetMinutes < 0 ? '-' : '+';
  const absolute = Math.abs(offsetMinutes);
  const hours = String(Math.floor(absolute / MINUTES_PER_HOUR)).padStart(
    2,
    '0',
  );
  const minutes = String(absolute % MINUTES_PER_HOUR).padStart(2, '0');
  return `GMT${sign}${hours}:${minutes}`;
};

const getZoneOffsetLabel = (zone: string, date: Date): string | undefined =>
  new Intl.DateTimeFormat('en-US', {
    timeZone: zone,
    timeZoneName: 'longOffset',
  })
    .formatToParts(date)
    .find(({ type }) => type === 'timeZoneName')?.value;

const findZoneAtOffset = (
  offsetMinutes: number,
  date: Date,
): string | undefined => {
  const label = formatOffset(offsetMinutes);
  return Intl.supportedValuesOf?.('timeZone').find(
    (zone) => getZoneOffsetLabel(zone, date) === label,
  );
};

// Last-resort zone when the engine cannot name the device zone: right for the offset at `date`, not across DST.
export const getOffsetTimeZone = (date: Date = new Date()): string => {
  const offsetMinutes = -date.getTimezoneOffset();
  if (offsetMinutes === 0) {
    return 'UTC';
  }
  if (offsetMinutes % MINUTES_PER_HOUR === 0) {
    const hours = offsetMinutes / MINUTES_PER_HOUR;
    // IANA's Etc zones invert the sign: UTC+2 is Etc/GMT-2
    return `Etc/GMT${hours > 0 ? '-' : '+'}${Math.abs(hours)}`;
  }
  return findZoneAtOffset(offsetMinutes, date) ?? 'UTC';
};
